import React from 'react';
import { Helmet } from 'react-helmet';
import { GlobalConfigProps } from '../../services';
import { WINDOW_LOCATION_HOST, JENTIS_CONFIG } from './jentis.constants';

interface JentisProps {
  globalConfig: Partial<GlobalConfigProps>;
}

const setJentisConfigValues = (url: string) => {
  let domain: JENTIS_CONFIG;
  let env: JENTIS_CONFIG;
  let script: JENTIS_CONFIG;
  switch (url) {
    case WINDOW_LOCATION_HOST.LOCALHOST:
      /** localhost testing purpose only */
      /* domain = JENTIS_CONFIG.LOCALHOST_DOMAIN;
      env = JENTIS_CONFIG.LOCALHOST_ENV;
      script = JENTIS_CONFIG.LOCALHOST_SCRIPT;
      return { domain, env, script }; */
      return {};
    case WINDOW_LOCATION_HOST.LIVE:
      domain = JENTIS_CONFIG.LIVE_DOMAIN;
      env = JENTIS_CONFIG.LIVE_ENV;
      script = JENTIS_CONFIG.LIVE_SCRIPT;
      return { domain, env, script };
    case WINDOW_LOCATION_HOST.RCM:
      domain = JENTIS_CONFIG.RCM_DOMAIN;
      env = JENTIS_CONFIG.RCM_ENV;
      script = JENTIS_CONFIG.RCM_SCRIPT;
      return { domain, env, script };
    case WINDOW_LOCATION_HOST.RCMI:
      domain = JENTIS_CONFIG.RCMI_DOMAIN;
      env = JENTIS_CONFIG.RCMI_ENV;
      script = JENTIS_CONFIG.RCMI_SCRIPT;
      return { domain, env, script };
    default:
      return {};
  }
};

export const Jentis = ({ globalConfig }: JentisProps): JSX.Element => {
  const { domain, env, script } = globalConfig?.jentisConfig || (typeof window !== 'undefined' ? setJentisConfigValues(window?.location?.host) : {});

  if (!domain || !env || !script) {
    return null;
  }

  return (
    <Helmet>
      <script type="text/javascript">
        {`
                    (function(sCDN, sCDNProject, sCDNWorkspace, sCDNVers) {
                        if (window.localStorage !== null && typeof window.localStorage === "object" && typeof window.localStorage.getItem === "function" && window.sessionStorage !== null && typeof window.sessionStorage === "object" && typeof window.sessionStorage.getItem === "function") {
                            sCDNVers = window.sessionStorage.getItem('jts_preview_version') || window.localStorage.getItem('jts_preview_version') || sCDNVers;
                        }

                        window.jentis = window.jentis || {};
                        window.jentis.config = window.jentis.config || {};
                        window.jentis.config.frontend = window.jentis.config.frontend || {};
                        window.jentis.config.frontend.cdnhost = sCDN + "/get/" + sCDNWorkspace + "/web/" + sCDNVers + "/";
                        window.jentis.config.frontend.vers = sCDNVers;
                        window.jentis.config.frontend.env = sCDNWorkspace;
                        window.jentis.config.frontend.project = sCDNProject;
                        window._jts = window._jts || [];
                        
                        var f = document.getElementsByTagName("script")[0];
                        var j = document.createElement("script");
                        j.async = true;
                        j.src = window.jentis.config.frontend.cdnhost + "${script}.js";
                        f.parentNode.insertBefore(j, f)
                    })("${domain}", "${env}", "live", "_");
                `}
      </script>
    </Helmet>
  );
};
